import { useFormat } from '@ideavivat/vivat-2';
import usePayment from '@/usePayment';
import useDelivery from '@/useDelivery';
import type { TempDeliveryStatus } from '@/useDelivery';
import type { VehicleType } from '@/useVehicle';
import {
  _primaryControls,
  _increment,
  orderNumber,
  totalWeight,
  type,
} from './base';
import useVehicle from '@/useVehicle';

const { translate: paymentMethodTranslate } = usePayment();
const {
  tempDeliveryStatusClassMap,
  tempDeliveryStatusTranslate,
} = useDelivery();
const {
  translate: vehicleTypeTranslate,
} = useVehicle();

export default {
  types: {
    _primaryControls,
    _selectorControls: {
      width: '3rem',
      class: 'text-center',
    },
    _increment,
    orderNumber,
    status: {
      name: 'สถานะ',
      width: '6rem',
      filter: (val: TempDeliveryStatus) => tempDeliveryStatusTranslate(val),
      class: {
        text: (val: TempDeliveryStatus) => tempDeliveryStatusClassMap(val),
        cell: 'text-center',
      },
    },
    type,
    vehicleType: {
      name: 'ประเภทรถ',
      width: '8rem',
      class: 'text-left',
      filter: (val: any, row: any) => vehicleTypeTranslate(row.item?.vehicleType?.vehicleType) || '-',
    },
    totalWeight,
    'packages.length': {
      name: 'จำนวนรายการ',
      width: '8rem',
      class: 'text-right',
    },
    customerName: {
      name: 'ชื่อลูกค้า',
      width: '10rem',
    },
    senderPhone: {
      name: 'เบอร์โทรผู้ฝากส่ง',
      width: '8rem',
      filter: (val: any, row: any) => `${row.item?.senderPhone || ''}`,
    },
    customerPhone: {
      name: 'เบอร์โทรผู้รับ',
      width: '8rem',
      filter: (val: any, row: any) => `${row.item?.customerPhone || ''}`,
    },
    address: {
      name: 'ที่อยู่ในการจัดส่ง',
      width: '14rem',
      filter: (val: any) => `${val.address} ${val.province?.nameInThai} ${val.district?.nameInThai ? val.district?.nameInThai : ''} ${val.subdistrict?.nameInThai ? val.subdistrict?.nameInThai : ''} ${val.zipcode}`,
    },
    remark: {
      name: 'หมายเหตุ',
      width: '8rem',
      class: 'break-words',
    },
    // eslint-disable-next-line
    created_at: {
      name: 'วันที่รายการเข้าระบบ',
      width: '10rem',
      filter: (val: string, row: any) => useFormat.date(row.item.createdAt).displayShortThaiDateTime(),
      class: 'text-right',
    },
  },
  sortable: [
    'orderNumber',
    'customerName',
    'created_at',
  ],
};
